import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=6a1c1122&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=6a1c1122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1c1122",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1c1122')) {
      api.createRecord('6a1c1122', component.options)
    } else {
      api.reload('6a1c1122', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=6a1c1122&scoped=true&", function () {
      api.rerender('6a1c1122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2pAH2WD1tW1Z9/JS/comp/GuestBox.vue"
export default component.exports